import { LitElement } from 'lit';

/**
 * Base class para todos los componentes del kit.
 *
 * Convenciones:
 * - Light DOM: hereda tokens --ui-* y fuentes del host, evita reinyectar estilos.
 * - _emit(name, detail): CustomEvent con namespace "ext:<name>", bubbles + composed + cancelable.
 */
export class ExtBaseElement extends LitElement {
  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  protected _emit<T = unknown>(name: string, detail?: T): boolean {
    return this.dispatchEvent(
      new CustomEvent<T>(`ext:${name}`, {
        detail,
        bubbles: true,
        composed: true,
        cancelable: true,
      })
    );
  }
}
